module.exports = __webpack_public_path__ + "static/media/stopred.a5d0e48a.svg";